export const GET_TICKET_ACTIONS_SUCCESS = 'GET_TICKET_ACTIONS_SUCCESS';
export const ADD_TICKET_ACTION_SUCCESS = 'ADD_TICKET_ACTION_SUCCESS';
export const DELETE_TICKET_ACTION_SUCCESS = 'DELETE_TICKET_ACTION_SUCCESS';
export const SET_FETCHING_TICKET_ACTION = 'SET_FETCHING_TICKET_ACTION';